const dots = [
  { top: "8%", left: "4%", size: 26, color: "rgba(52,211,153,0.35)", delay: "0s" },
  { top: "22%", left: "90%", size: 34, color: "rgba(52,211,153,0.25)", delay: "1.2s" },
  { top: "38%", left: "12%", size: 18, color: "rgba(52,211,153,0.4)", delay: "2.4s" },
  { top: "55%", left: "84%", size: 22, color: "rgba(240,180,41,0.3)", delay: "0.6s" },
  { top: "70%", left: "6%", size: 30, color: "rgba(52,211,153,0.3)", delay: "3s" },
  { top: "82%", left: "76%", size: 16, color: "rgba(52,211,153,0.45)", delay: "1.8s" },
  { top: "15%", left: "55%", size: 14, color: "rgba(240,180,41,0.35)", delay: "2s" },
  { top: "90%", left: "35%", size: 24, color: "rgba(52,211,153,0.28)", delay: "0.9s" },
  { top: "48%", left: "45%", size: 12, color: "rgba(52,211,153,0.5)", delay: "3.6s" },
];

export default function Bokeh() {
  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true">
      {dots.map((d, i) => (
        <span
          key={i}
          className="bokeh-dot"
          style={{
            top: d.top,
            left: d.left,
            width: d.size,
            height: d.size,
            background: d.color,
            animationDelay: d.delay,
          }}
        />
      ))}
    </div>
  );
}
